export default "__VITE_PUBLIC_ASSET__a178272f__"